import { User } from "@/core/models/global/User";
import { UserResponse } from "./UserResponse";
import { __UserResponseInternals } from "./UserResponse";

const { BaseObject, toUserInstance } = __UserResponseInternals;

export class LoginResponse extends UserResponse {
    constructor(args: { user?: User; token?: string }) {
        super("login", args.user, args.token);
    }

    static schema = BaseObject.transform((raw) => {
        const token = (raw as any).token as string | undefined;
        const user = toUserInstance((raw as any).user);
        return new LoginResponse({ token: token, user: user });
    });

    static fromJSON(raw: unknown): LoginResponse {
        return LoginResponse.schema.parse(raw);
    }
}
